class FormCreateTool {
    list;
    constructor(list) {
        this.list = list;
        return this;
    }
    setInputs(field, value) {
        this.list.forEach(i => {
            if (field.includes(i.field)) {
                Object.assign(i, value);
            }
        })
    }
}
export default FormCreateTool;
